/** Resources whose admin custom fetcher supports `filter.isExport` (lightweight export pipeline). */
export const resourcesWithExportPipeline = new Set(['therapists']);

/** Passed to react-admin `ExportButton` → `dataProvider.getList` for legacy CSV export. */
export const legacyExportGetListMeta = {
  forExport: true,
  raw: true,
  facet: false,
} as const;
